"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLengthRule = void 0;
var validation_rule_1 = require("./validation-rule");
var ListLengthRule = /** @class */ (function (_super) {
    __extends(ListLengthRule, _super);
    function ListLengthRule(rootType, options) {
        var _this = this;
        // ensure the rule name is specified
        options.name = options.name || "ListLength";
        options.message = function () {
            var range = {};
            if (options.min && options.min instanceof Function) {
                try {
                    range.min = options.min.call(this);
                }
                catch (e) {
                    // Silently ignore min errors
                }
            }
            else if (typeof (options.min) === "number") {
                range.min = options.min;
            }
            if (options.max && options.max instanceof Function) {
                try {
                    range.max = options.max.call(this);
                }
                catch (e) {
                    // Silently ignore max errors
                }
            }
            else if (typeof (options.min) === "number") {
                range.min = options.min;
            }
            var val = options.property.value(this);
            if (!val) {
                return null;
            }
            if ((range.min == null || val.length >= range.min) && (range.max == null || val.length <= range.max)) {
                // Value is within range
                return null;
            }
            if (range.min != null && range.max != null)
                return rootType.model.getResource("listlength-between").replace("{min}", range.min.toString()).replace("{max}", range.max.toString());
            if (range.min != null)
                return rootType.model.getResource("listlength-at-least").replace("{min}", range.min.toString());
            else
                return rootType.model.getResource("listlength-at-most").replace("{max}", range.max.toString());
        };
        // call the base type constructor
        _this = _super.call(this, rootType, options) || this;
        return _this;
    }
    return ListLengthRule;
}(validation_rule_1.ValidationRule));
exports.ListLengthRule = ListLengthRule;
